const prepareDateRange = (next, previous) => {
    if (!next && !previous)
        return null;

    if (next && (next.to || next.from)) {
        return {
            from: next.from,
            to: next.to
        };
    }

    return {
        from: previous.from,
        to: previous.to
    };
}

const prepareTime = (next, previous) => {
    if (!next && !previous)
        return null

    if(next){
        return next
    }

    return previous
}

const prepareArray = (previous, next) => {
    if (!next)
        return null

    let result = []
    if (Array.isArray(next))
        result = next
    else if (Number.isInteger(next))
        result = [next]

    if (JSON.stringify(previous) === JSON.stringify(next))
        return null

    return result
}

const prepareEventName = (previous, next) => {
    if (next === null || previous === null)
        return null
    if(next !== null)
        return next

    return previous
}

export default (previous, next) => {
    let filter = { ...previous }

    filter.type = next.type

    const time = prepareTime(next.time, previous.time)
    if (time !== null)
        filter = { ...filter, time}
    else{
        filter = { ...filter, time: undefined  }
    }
    const dateRange = prepareDateRange(next.dateRange, previous.dateRange)
    if (dateRange !== null)
        filter = { ...filter, dateRange }
    else{
        filter = { ...filter, dateRange: { from: undefined, to: undefined }}
    }
    const volatilities = prepareArray(previous.volatilities, next.volatilities)
    if (volatilities !== null)
        filter.volatilities = volatilities

    const countries = prepareArray(previous.countries, next.countries)
    if (countries !== null)
        filter.countries = countries

    const categories = prepareArray(previous.categories, next.categories)
    if (categories !== null)
        filter.categories = categories

    const eventName = prepareEventName(previous.eventName, next.eventName)
    if (eventName !== null)
        filter.eventName = eventName

    if (filter === previous)
        return null

    return filter
}
